<template>
    <div class="header_content" :style="{borderBottom:(queryParams.fromPage == 'productList'  ? '1px solid #EEEEEE' : '')}">
        <div class="header_activity_area" v-if="queryParams.fromPage == 'home' && isShowNewProduct && bannerList.length > 0">
            <el-carousel trigger="click" :interval="5000" height="120px" indicator-position="none">
                <el-carousel-item v-for="(banner, index) in bannerList" :key="index">
                    <img height="100%" class="header_activity" :src="banner.url" @click="toPagesList(banner)" />
                </el-carousel-item>
            </el-carousel>
            <img class="header_activity_close" @click="closeNewProduct" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/index_header_close.png" alt="">
        </div>
        <div class="hearder_div">
            <div class="header_logo">
                <!-- <img class="header_logo_img" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/logo/logo.gif" @click="toIndex" /> -->
                <img class="header_logo_img" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/login/indexTop.png" @click="toIndex" />
            </div>
            <div class="header_info">
                <search-com />
                <div class="search_key_recommend">
                    <span class="strokeDiv" v-for="item in keyWordsList" :key="item.id" @click="toPagesList(item)">{{item.word}}</span>
                </div>
            </div>
            <simple-cart leftValue="30" />
        </div>
        <div class="header_bottom">
            <category-list :categoryType="(queryParams.fromPage == 'home' ? 'home' : '')" />
            <div class="hear_menus">
                <div :class="index==1&&queryParams.fromPage=='newProduct' || index==3&&queryParams.fromPage=='articleDetail' || index == 0 && queryParams.fromPage == 'home' || index == 4 &&  queryParams.fromPage == 'article' || index == 2 &&  queryParams.fromPage == 'sample' ? 'onSelect' : ''" class="strokeDiv" v-for="(item,index) in titleList" :key="item.id" @click="toOtherPages(item,index)">{{item.word}}</div>
            </div>
        </div>
        <scroll-head />
    </div>
</template>
<script>
import { getRecommendKeyWord } from "@/api/index/keyWordsApi";
import {
    getIndexNavigation,
    getIndexTopBannerList,
} from "@/api/index/indexApi";
import SimpleCart from "../cart/SimpleCart.vue";
import searchCom from "./searchCom.vue";
import scrollHead from "./scrollHead.vue";
import categoryList from "./categoryList.vue";
import $ from "jquery";
export default {
    components: { SimpleCart, searchCom, scrollHead, categoryList },
    inject: ["reload"], //注入强制刷新依赖
    props: {
        queryParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return {
            keyWordsList: [],
            isShowNewProduct: true,
            titleList: [],
            bannerList: [],
        };
    },
    mounted() {
        this.isShowNewProduct =
            sessionStorage.getItem("isShowNewProduct") == "false"
                ? false
                : true;
        this.initCategoryTreeData();
    },
    computed: {
        loginName: function () {
            return this.$store.getters.getUserName;
        },
    },
    methods: {
        initCategoryTreeData() {
            //获取推荐关键词
            getRecommendKeyWord().then((res) => {
                if (res.success) {
                    this.keyWordsList = res.data;
                }
            });
            getIndexNavigation().then((res) => {
                if (res.success) {
                    this.titleList = res.data;
                    this.titleList.unshift({
                        id: "100000001",
                        remark: "",
                        sort: "",
                        status: "",
                        type: "",
                        linkUrl: "/",
                        word: "首页",
                    });
                }
            });
            getIndexTopBannerList().then((res) => {
                if (res.success) {
                    this.bannerList = res.data;
                }
            });
        },
        closeNewProduct() {
            sessionStorage.setItem("isShowNewProduct", false);
            this.isShowNewProduct = false;
        },
        toOtherPages(item, index) {
            if (index == 0) {
                this.isShowNewProduct =
                    sessionStorage.getItem("isShowNewProduct") == "false"
                        ? false
                        : true;
            }
            var str = item.linkUrl.split('')[0]
            if(str=='/'){
                this.$router.push({ path: item.linkUrl })
            }else{
                window.open(item.linkUrl)
            }
        },
        toPagesList(item) {
            window.location.href = item.linkUrl;
        },
        toIndex() {
            this.$router.push({ path: "/" });
        },
    },
};
</script>
<style scoped>
.header_content {
    width: 100%;
    min-width: 1200px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.header_activity_area {
    position: relative;
    width: 1200px;
    cursor: pointer;
}
.header_activity {
    width: 1200px;
    height: 120px;
}
.header_activity_close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    right: 7px;
    z-index: 2;
    cursor: pointer;
}
.hearder_div {
    width: 1200px;
    height: 117px;
    display: inline-block;
    display: flex;
    /* justify-content: center; */
    align-items: center;
}
.header_logo {
    width: 253px;
    height: 117px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 7px;
}
.header_logo_img {
    width: 196px;
    cursor: pointer;
}
.header_info {
    /* width: 947px; */
    height: 117px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    float: left;
}
.search_key_recommend {
    position: relative;
    top: 5px;
    width: 660px;
    height: 14px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666;
    line-height: 14px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.search_key_recommend span {
    padding: 0 10px;
}
/* 商品分类 */
.header_bottom {
    width: 1200px;
    height: 40px;
    display: flex;
    align-items: center;
}
/* 首页，关于我们 */
.hear_menus {
    width: 644px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}
.hear_menus > div {
    flex: 1;
    cursor: pointer;
    text-align: center;
}
.onSelect {
    color: #e1251b;
}
</style>
<style>
/*deep*/
.el-dropdown {
    display: inline-block;
    position: relative;
    color: #333333;
    font-size: 16px;
}
.el-menu.el-menu--horizontal {
    border-bottom: solid 0px #e6e6e6;
    border-bottom: 0px solid transparent;
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px solid #409eff;
}
.el-menu--horizontal > .el-menu-item {
    height: 50px;
    line-height: 50px;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/header.vue